import { customPayloadTypes, surveyForm, customFieldTypes, chatEvents } from "./constants";
import { changeCWLanguage } from "./utils";

export function processCustomPayload ({ attachments, triggerType, customPayload, customFields }) {
  const languageCode = customPayload[customPayloadTypes.TRANSLATE_LANGUAGE]
  if (languageCode && !isResponseOnlyScheduleSurvey(attachments, triggerType, customFields)) {
    changeCWLanguage(languageCode)
  }
}

function isResponseOnlyScheduleSurvey (attachments, triggerType, customFields) {
  if ((attachments && attachments.length === 0) && (customFields && customFields.length === 1 && customFields[0].name === customFieldTypes.SURVEY_SCHEMA) && triggerType === chatEvents.RESPONSE) {
    const value = JSON.parse(customFields[0]?.values)
    if (value && [surveyForm.WIDGET_EVENT_CHAT_END, surveyForm.WIDGET_EVENT_IDLE_USER, surveyForm.WIDGET_EVENT_SESSON_EXPIRE].includes(value.triggerType)) {
      return true
    }
  }
  return attachments?.length === 0
}
